export const initialSocialMediaFile = {
  id: 0,
  socialMediaId: 0,
  previewPath: '',
  originPath: '',
  platforms: [],
  format: '',
  fName: '',
  fExtension: '',
  fDimensions: '',
  fSize: 0,
  isVisible: false,
}
